<template>
  <PageWrapper
    v-if="canView"
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_ADVERTISING"
    title="Advertising Settings"
    :breadcrumbs="breadcrumbs"
    page-name="Advertising Settings"
    align="center"
    width="full"
    action-button-text="Create Ad"
    @click:action="openCreateAdModal"
  >
    <PublicationAdvertisingSettings :show-heading="false" :publication="publication" />
    <CreatePublicationAdModal />
  </PageWrapper>
  <iText v-else>
    You don't have access to view this page.
  </iText>
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import { mapActions, mapState } from "pinia";
import {
  PAGE_PUBLICATION_ADVERTISING,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { useMyAdsFeedStore } from "@/smart-feed/stores/feed/my-ads-feed-store";
import CreatePublicationAdModal from "@/components/publication/CreatePublicationAdModal.vue";
import { usePublicationAdsStore } from "%/stores/publication-ads-store";
import PublicationAdvertisingSettings from "%/components/advertising/PublicationAdvertisingSettings.vue";
import { useCollaboratorStore } from "@/stores/collaborator-store";

export default {
  name: "PublicationAdvertising",
  components: { PublicationAdvertisingSettings, CreatePublicationAdModal, PageWrapper },
  data() {
    return {
      PAGE_PUBLICATION_ADVERTISING,
      SECTION_PUBLICATIONS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "orgId",
      "publicationId",
      "publication",
    ]),
    ...mapState(useCollaboratorStore, [
      "canView",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
        {
          url: `/publication/${this.publicationId}`,
          label: "Overview",
        },
      ];
    },
  },
  mounted() {
    if (!this.canView) {
      const baseUrl = window.location.origin;
      const redirectUrl = `${baseUrl}/publication/${this.publicationId}`;

      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);
    }
  },
  methods: {
    useMyAdsFeedStore,
    ...mapActions(usePublicationAdsStore, ["openCreateAdModal"]),
  },
};
</script>

<style scoped lang="scss"></style>
